export { TeachingPopoverCarouselFooter } from './TeachingPopoverCarouselFooter';
export { useTeachingPopoverCarouselFooter } from './useTeachingPopoverCarouselFooter';
export { renderTeachingPopoverCarouselFooter } from './renderTeachingPopoverCarouselFooter';
export type {
  TeachingPopoverCarouselFooterProps,
  TeachingPopoverCarouselFooterSlots,
  TeachingPopoverCarouselFooterState,
} from './TeachingPopoverCarouselFooter.types';
